import { AxiosError } from 'axios';
import React from 'react';
import { useQuery } from 'react-query';
import { Route, useLocation } from 'react-router-dom';

import Loading from 'components/atoms/Loading';
import Errors from 'components/templates/Errors';
import i18n, { changeStoreLanguage } from 'i18n';
import { redirectPageService } from 'services/pages';
import { useAppDispatch } from 'store/hooks';
import { setLanguage } from 'store/system';
import { DEFAULT_QUERY_OPTION } from 'utils/constants';
import { checkExternalUrl, checkIsStorage } from 'utils/functions';

interface RedirectNavigateProps {
  error: unknown;
}

export const Redirect301: React.FC = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  const { isLoading, data } = useQuery(
    ['GetPageData', pathname],
    () => redirectPageService(pathname),
    {
      ...DEFAULT_QUERY_OPTION,
    },
  );

  if (isLoading) return <Loading variant="fullScreen" isShow />;

  if (data) {
    const isStorage = checkIsStorage(data.to);
    const isExternal = checkExternalUrl(data.to);
    const checkLanguage = changeStoreLanguage(data.to);
    if (checkLanguage.change) {
      i18n.changeLanguage(checkLanguage.language);
      dispatch(setLanguage(checkLanguage.language));
    }

    if (isStorage) {
      window.open(new URL(data.to, window.location.origin).href, '_self');
      return null;
    }
    if (isExternal) {
      return (
        <Route
          path=""
          component={() => {
            window.location.replace(data.to);
            return null;
          }}
        />
      );
    }

    window.open(new URL(data.to, window.location.origin).href, '_self');
    return null;
  }
  return <Errors statusCode={404} />;
};

const RedirectNavigate: React.FC<RedirectNavigateProps> = ({ error }) => {
  const errorCode = (error as AxiosError)?.response?.status || 0;
  if (errorCode >= 500) {
    return <Errors statusCode={500} />;
  }
  if (errorCode === 404) {
    return <Redirect301 />;
  }

  return null;
};

export default RedirectNavigate;
